import { render, staticRenderFns } from "./RegistroPreaspirante.vue?vue&type=template&id=0f7c835e&scoped=true"
import script from "./RegistroPreaspirante.vue?vue&type=script&lang=js"
export * from "./RegistroPreaspirante.vue?vue&type=script&lang=js"
import style0 from "./RegistroPreaspirante.vue?vue&type=style&index=0&id=0f7c835e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c835e",
  null
  
)

export default component.exports